/*
 * ██████╗ ██╗████████╗███████╗ █████╗  ██████╗████████╗ ██████╗ ██████╗ ██╗   ██╗
 * ██╔══██╗██║╚══██╔══╝██╔════╝██╔══██╗██╔════╝╚══██╔══╝██╔═══██╗██╔══██╗╚██╗ ██╔╝
 * ██████╔╝██║   ██║   █████╗  ███████║██║        ██║   ██║   ██║██████╔╝ ╚████╔╝
 * ██╔══██╗██║   ██║   ██╔══╝  ██╔══██║██║        ██║   ██║   ██║██╔══██╗  ╚██╔╝
 * ██████╔╝██║   ██║   ██║     ██║  ██║╚██████╗   ██║   ╚██████╔╝██║  ██║   ██║
 * ╚═════╝ ╚═╝   ╚═╝   ╚═╝     ╚═╝  ╚═╝ ╚═════╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝   ╚═╝
 *
 *
 * Copyright (c) Bitfactory GmbH. All rights reserved.
 * https://www.bitfactory.io
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
 * FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
 * INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
 * ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

import { makeStyles } from 'tss-react/mui';

import { Theme } from '@mui/material/styles';

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export const ChoiceViewUseStyles = makeStyles()((theme: Theme) => ({
	container: {
		margin: theme.spacing(5, 0),
	},

	box: {
		display: 'flex',
		marginBottom: theme.spacing(2),
		alignItems: 'flex-start',
	},

	textSelectBox: {
		marginTop: theme.spacing(0.5),
	},

	checkbox: {
		width: '14px',
		height: '14px',
		borderWidth: '1px',
		borderStyle: 'solid',
		borderColor: '#7A5C06',
		borderRadius: '2px',
		boxShadow: '0 0 0 0.5px #00000080, 0 1px 3px 0 #0000003D, 0 2px 8px 0 #0000001F',
	},

	text: {
		width: '330px',
		paddingLeft: theme.spacing(2),
	},

	image: {
		marginLeft: theme.spacing(2),
		width: '305px',
		borderRadius: '8px',
		boxShadow: '0 0 0 0.5px #00000080, 0 1px 3px 0 #0000003D, 0 2px 8px 0 #0000001F',
	},

	radioChecked: {
		display: 'flex',
		width: '14px',
		height: '14px',
		backgroundColor: theme.palette.primary.main,
		borderRadius: '50%',
		borderStyle: 'solid',
		borderWidth: '1px',
		borderColor: '#7A5C06',
		boxShadow: '0 0 0 0.5px #00000080, 0 1px 3px 0 #0000003D, 0 2px 8px 0 #0000001F',
	},

	radioCheckedInside: {
		margin: 'auto',
		width: '8px',
		height: '8px',
		borderRadius: '50%',
		backgroundColor: '#7A5C06',
		zIndex: 9,
	},

	radioUnchecked: {
		width: '14px',
		height: '14px',
		backgroundColor: theme.palette.background.paper,
		borderRadius: '50%',
		borderStyle: 'solid',
		borderWidth: '1px',
		boxShadow: '0 0 0 0.5px #00000080, 0 1px 3px 0 #0000003D, 0 2px 8px 0 #0000001F',
	},
}));
